export const COEFFICIENT = 16 / 9;
